module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMG1tIiBoZWlnaHQ9IjMwbW0iIHZpZXdCb3g9IjAgMCAzMDAwIDMwMDAiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiB0ZXh0LXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiBpbWFnZS1yZW5kZXJpbmc9Im9wdGltaXplUXVhbGl0eSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5maWwwIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogI0YwMDsKICAgICAgICBzdHJva2Utd2lkdGg6IDEwMDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGc+CiAgICA8Y2lyY2xlIGN4PSIxNTAwIiBjeT0iMTUwMCIgcj0iMTQ1MCIgY2xhc3M9ImZpbDAiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/red_circle.svg
// module id = 4mtj
// module chunks = 1